<template>
  <q-tab-pane name="quotes" class="no-padding">
    <div class="layout-padding">
      <div v-if="hasQuotes">
        <q-btn outline color="primary" icon="add" :label="$tc('quote', 1)" @click="handleCreateQuote"></q-btn>
        <div class="row gutter-sm q-mt-sm">
          <div v-for="quote in quotes" :key="quote.id" class="col-xs-12 col-sm-6 col-md-4 col-xl-3">
            <quote-card :quote="quote"/>
          </div>
        </div>
      </div>

      <template v-else>
        <div class="row justify-center items-center col-grow q-pt-lg">
          <div class="text-center">
            <img src="~assets/emptystates/invoices_empty.svg" width="40%"/>

            <h6 class="q-my-md text-faded">{{ $t('quotes_empty') }}</h6>

            <q-btn @click="handleCreateQuote" color="primary" class="q-mt-lg" outline v-is-user>
              {{ $t('create_quote') }}
            </q-btn>
          </div>
        </div>
      </template>
    </div>
  </q-tab-pane>
</template>

<script>
  import QuoteCard from 'components/Quotes/QuoteCard.vue'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      project: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters(['activeTeam']),

      quotes () {
        return this.project.quotes ? this.project.quotes.data : []
      },

      hasQuotes () {
        return !!this.quotes.length
      }
    },

    methods: {
      handleCreateQuote () {
        this.$router.push({
          name: 'create-quote',
          params: { teamId: this.activeTeam.id },
          query: {
            project: this.project.id
          }
        })
      }
    },

    components: {
      QuoteCard
    }
  }
</script>
